import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <UpdatesSection />
        <CardsSection />
        <CommentsSection />
        <AboutSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}